import { AddFilled, BriefcaseFilled } from '@fluentui/react-icons';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface HomeworkSelectionProps {
  canCreateTeamsAssignment: boolean;
  selected: (withTeamsAssignment: boolean) => void;
}

export const HomeworkSelection: FC<HomeworkSelectionProps> = (props) => {
  const { canCreateTeamsAssignment, selected } = props;
  const { t } = useTranslation();
  return (
    <div className="flex justify-center homeworkSelection">
      <button
        type="button"
        className="teamsAssignmentBtn tile"
        onClick={() => selected(false)}
      >
        <AddFilled className="assignmentIcon" />
        <div className="text">
          {t('classbook:newassignment:dialog_new_assignment', { defaultValue: 'Neue Aufgabe' })}
        </div>
      </button>

      <button
        type="button"
        className="teamsAssignmentBtn tile"
        disabled={!canCreateTeamsAssignment}
        onClick={() => selected(true)}
      >
        <BriefcaseFilled className="assignmentIcon" />
        <div className="text">
          {t('classbook:newassignment:dialog_connect_teams', {
            defaultValue: 'Mit Teams verknüpfen',
          })}
        </div>
      </button>
    </div>
  );
};
